import React, { useEffect, useState } from "react";
import Select from "react-select";
import axiosInstance from "../../axiosInstance";

const OrderAdvancedFilters = ({
  filters,
  onFilterChange,
  selectedDriver,
  onDriverChange,
  includeRange = true,
}) => {
  const [personOptions, setPersonOptions] = useState([]);
  const selectedFilterType = filters.filterType || "driver";
  const inputStyle = {
    width: "100%",
    height: 40,
    border: "1.5px solid #e2e8f0",
    borderRadius: 10,
    padding: "0 12px",
    fontSize: 14,
    color: "#1e293b",
    background: "#f8fafc",
    outline: "none",
  };
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 40,
      height: 40,
      borderRadius: 10,
      borderWidth: "1.5px",
      borderColor: state.isFocused ? "#3b82f6" : "#e2e8f0",
      background: state.isFocused ? "#fff" : "#f8fafc",
      boxShadow: "none",
      "&:hover": { borderColor: "#3b82f6" },
    }),
    valueContainer: (base) => ({ ...base, height: 40, padding: "0 10px" }),
    indicatorsContainer: (base) => ({ ...base, height: 40 }),
    menu: (base) => ({ ...base, zIndex: 1050 }),
    option: (base, state) => ({
      ...base,
      fontSize: 14,
      background: state.isSelected ? "#2563eb" : state.isFocused ? "#eff6ff" : "#fff",
      color: state.isSelected ? "#fff" : "#1e293b",
    }),
  };

  useEffect(() => {
    const fetchPeople = async () => {
      try {
        const endpoint = selectedFilterType === "user"
          ? "/admin/all-user?page=1&limit=1000&type=2"
          : "/all-employee?type=1&empType=2";
        const response = await axiosInstance.get(endpoint);
        const people = selectedFilterType === "user"
          ? response.data.users || []
          : response.data.users || [];

        setPersonOptions(
          people.map((person) => ({
            value: person._id,
            label: `${person.username || (selectedFilterType === "user" ? "Customer" : "Driver")}${person.phone ? ` (${person.phone})` : ""}`,
          }))
        );
      } catch (error) {
        console.error("Error fetching order filter options:", error);
        setPersonOptions([]);
      }
    };

    fetchPeople();
  }, [selectedFilterType]);

  return (
    <>
      <style>{`
        /* Flex-wrap filter bar: reflows naturally instead of fixed 14-col grid */
        .order-filter-grid {
          display: flex !important;
          flex-wrap: wrap;
          gap: 16px;
          align-items: flex-end;
        }
        .order-filter-grid > .filter-group {
          flex: 1 1 160px;
          min-width: 140px;
        }
        .order-filter-grid .filter-per-page {
          flex: 0 1 100px;
          min-width: 90px;
        }
        .order-filter-grid .filter-order-search {
          flex: 2 1 220px;
          min-width: 200px;
        }
        .order-filter-grid .filter-date {
          flex: 1 1 155px;
          min-width: 150px;
        }
        .order-filter-grid .filter-hour {
          flex: 1 1 110px;
          min-width: 100px;
        }
        .order-filter-grid .filter-driver {
          flex: 2 1 240px;
          min-width: 220px;
        }
        .order-filter-grid .filter-payment {
          flex: 1 1 140px;
          min-width: 130px;
        }
        .order-filter-grid .filter-action {
          flex: 0 1 130px;
          min-width: 120px;
        }
        .order-filter-grid .filter-action button {
          width: 100%;
        }
        .order-filter-grid .reset-btn {
          height: 40px;
          padding: 0 18px;
          border: 1.5px solid #cbd5e1;
          border-radius: 10px;
          background: #fff;
          color: #475569;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          transition: all .15s ease;
        }
        .order-filter-grid .reset-btn:hover {
          background: #f1f5f9;
          border-color: #94a3b8;
          color: #0f172a;
        }
        /* Forces a hard line break in the flex row wherever placed */
        .order-filter-grid .row-break {
          flex-basis: 100%;
          width: 0;
          height: 0;
          margin: 0;
          padding: 0;
        }
        @media (max-width: 767px) {
          .order-filter-grid > .filter-group {
            flex: 1 1 100%;
            min-width: 100%;
          }
        }
      `}</style>

      {includeRange && (
        <div className="filter-group filter-date">
          <label><i className="bi bi-calendar3 me-1"></i>From Date</label>
          <input className="filter-input" type="date" name="fromDate"
            style={inputStyle} value={filters.fromDate} onChange={onFilterChange} />
        </div>
      )}
      {includeRange && (
        <div className="filter-group filter-date">
          <label><i className="bi bi-calendar-check me-1"></i>To Date</label>
          <input className="filter-input" type="date" name="toDate"
            style={inputStyle} value={filters.toDate} onChange={onFilterChange} />
        </div>
      )}

      {/* Force Min/Max Hours (and everything after) onto a new row */}
      {includeRange && <div className="row-break"></div>}

      {includeRange && (
        <div className="filter-group filter-hour hour-filter">
          <label><i className="bi bi-clock-history me-1"></i>Min Hours</label>
          <input className="filter-input" type="number" min="0" name="minHours"
            style={inputStyle} value={filters.minHours} onChange={onFilterChange}
            onWheel={(event) => event.target.blur()} />
        </div>
      )}
      {includeRange && (
        <div className="filter-group filter-hour hour-filter">
          <label><i className="bi bi-clock me-1"></i>Max Hours</label>
          <input className="filter-input" type="number" min="0" name="maxHours"
            style={inputStyle} value={filters.maxHours} onChange={onFilterChange}
            onWheel={(event) => event.target.blur()} />
        </div>
      )}

      <div className="filter-group filter-payment">
        <label><i className="bi bi-funnel me-1"></i>Type</label>
        <select
          style={inputStyle}
          name="filterType"
          value={selectedFilterType}
          onChange={(event) => {
            onFilterChange(event);
            onDriverChange(null);
          }}
        >
          <option value="driver">Driver</option>
          <option value="user">Customer</option>
        </select>
      </div>

      <div className="filter-group filter-driver">
        <label><i className="bi bi-person-badge me-1"></i>Select {selectedFilterType === "user" ? "Customer" : "Driver"}</label>
        <Select
          isClearable
          isSearchable
          options={personOptions}
          value={selectedDriver}
          onChange={onDriverChange}
          placeholder={`Search ${selectedFilterType === "user" ? "customer" : "driver"}...`}
          classNamePrefix="driver-filter"
          styles={selectStyles}
          noOptionsMessage={() => `No ${selectedFilterType === "user" ? "customer" : "driver"} found`}
        />
      </div>
    </>
  );
};

export default OrderAdvancedFilters;
